"use client";

import React, { useEffect, useState } from "react";
import { FaChevronUp } from "react-icons/fa";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setVisible(window.scrollY > 320);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    // check on mount
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // hide while scrolling up — the listener will update visible automatically
  };

  return (
    <div
      aria-hidden={!visible}
      className={`fixed right-4 bottom-6 z-50 transition-opacity duration-300 ease-in-out transform-gpu ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <button
        aria-label="Scroll to top"
        onClick={handleClick}
        className="w-12 h-12 md:w-12 md:h-12 rounded-full flex items-center justify-center shadow-lg transition-transform duration-300 ease-out hover:scale-110 active:scale-95"
        style={{
          background: "linear-gradient(90deg, var(--themeColor) 0%, rgba(255,255,255,0.06) 100%)",
          WebkitBackdropFilter: "blur(6px)",
          backdropFilter: "blur(6px)",
          border: "0px solid rgba(255,255,255,0.06)",
        }}
      >
        <FaChevronUp className="text-white" />
      </button>
    </div>
  );
}
